import type { PlanData } from '../types/planDownload';

export const mockPlanData: PlanData[] = [
  {
    id: '1',
    productCode: 'T',
    planCode: 'I',
    hisPlanId: '2615',
    hisRevNo: '1',
    planDescription: 'Domestic Gold - Individual',
    effectiveDate: '3/1/2024',
    expirationDate: '2/1/2034',
    minimumDays: 1,
    maximumDays: 4,
    currency: 'PHP',
    grossPremium: 687,
    netPremium: 476.52,
    mrl: '2500000',
    coverageCode: 'P',
    availableForSalesAgent: false,
    occTemplate: 'OCC MyT_Individual_DOMGold_2023-08 (Aug 15)_COVID19',
    isCancelled: false,
    occPrefix: 'BU',
    tacticTemplate: 'Travel Insurance Contract (TACTIC)_2023-03 (March 13)',
    appFormTemplate: 'Travel Application Form (A4)_2023-03 (March 01)',
    planTax: 9.53,
    localTax: 0.95,
    gst: 200
  },
  {
    id: '2',
    productCode: 'T',
    planCode: 'I',
    hisPlanId: '2615',
    hisRevNo: '1',
    planDescription: 'Domestic Gold - Individual',
    effectiveDate: '3/1/2024',
    expirationDate: '2/1/2034',
    minimumDays: 5,
    maximumDays: 7,
    currency: 'PHP',
    grossPremium: 1084,
    netPremium: 864.97,
    mrl: '2500000',
    coverageCode: 'P',
    availableForSalesAgent: false,
    occTemplate: 'OCC MyT_Individual_DOMGold_2023-08 (Aug 15)_COVID19',
    isCancelled: false,
    occPrefix: 'BU',
    tacticTemplate: 'Travel Insurance Contract (TACTIC)_2023-03 (March 13)',
    appFormTemplate: 'Travel Application Form (A4)_2023-03 (March 01)',
    planTax: 17.3,
    localTax: 1.73,
    gst: 200
  },
  {
    id: '3',
    productCode: 'T',
    planCode: 'I',
    hisPlanId: '2615',
    hisRevNo: '1',
    planDescription: 'Domestic Gold - Individual',
    effectiveDate: '3/1/2024',
    expirationDate: '2/1/2034',
    minimumDays: 8,
    maximumDays: 10,
    currency: 'PHP',
    grossPremium: 1298,
    netPremium: 1074.36,
    mrl: '2500000',
    coverageCode: 'P',
    availableForSalesAgent: false,
    occTemplate: 'OCC MyT_Individual_DOMGold_2023-08 (Aug 15)_COVID19',
    isCancelled: false,
    occPrefix: 'BU',
    tacticTemplate: 'Travel Insurance Contract (TACTIC)_2023-03 (March 13)',
    appFormTemplate: 'Travel Application Form (A4)_2023-03 (March 01)',
    planTax: 21.49,
    localTax: 2.15,
    gst: 200
  },
  {
    id: '4',
    productCode: 'T',
    planCode: 'I',
    hisPlanId: '2615',
    hisRevNo: '1',
    planDescription: 'Domestic Gold - Individual',
    effectiveDate: '3/1/2024',
    expirationDate: '2/1/2034',
    minimumDays: 11,
    maximumDays: 15,
    currency: 'PHP',
    grossPremium: 1436,
    netPremium: 1209.39,
    mrl: '2500000',
    coverageCode: 'P',
    availableForSalesAgent: false,
    occTemplate: 'OCC MyT_Individual_DOMGold_2023-08 (Aug 15)_COVID19',
    isCancelled: false,
    occPrefix: 'BU',
    tacticTemplate: 'Travel Insurance Contract (TACTIC)_2023-03 (March 13)',
    appFormTemplate: 'Travel Application Form (A4)_2023-03 (March 01)',
    planTax: 24.19,
    localTax: 2.42,
    gst: 200
  },
  {
    id: '5',
    productCode: 'T',
    planCode: 'I',
    hisPlanId: '2615',
    hisRevNo: '1',
    planDescription: 'Domestic Gold - Individual',
    effectiveDate: '3/1/2024',
    expirationDate: '2/1/2034',
    minimumDays: 16,
    maximumDays: 24,
    currency: 'PHP',
    grossPremium: 1971,
    netPremium: 1732.87,
    mrl: '2500000',
    coverageCode: 'P',
    availableForSalesAgent: false,
    occTemplate: 'OCC MyT_Individual_DOMGold_2023-08 (Aug 15)_COVID19',
    isCancelled: false,
    occPrefix: 'BU',
    tacticTemplate: 'Travel Insurance Contract (TACTIC)_2023-03 (March 13)',
    appFormTemplate: 'Travel Application Form (A4)_2023-03 (March 01)',
    planTax: 34.66,
    localTax: 3.47,
    gst: 200
  },
  {
    id: '6',
    productCode: 'T',
    planCode: 'I',
    hisPlanId: '2615',
    hisRevNo: '1',
    planDescription: 'Domestic Gold - Individual',
    effectiveDate: '3/1/2024',
    expirationDate: '2/1/2034',
    minimumDays: 25,
    maximumDays: 31,
    currency: 'PHP',
    grossPremium: 2316,
    netPremium: 2070.45,
    mrl: '2500000',
    coverageCode: 'P',
    availableForSalesAgent: false,
    occTemplate: 'OCC MyT_Individual_DOMGold_2023-08 (Aug 15)_COVID19',
    isCancelled: false,
    occPrefix: 'BU',
    tacticTemplate: 'Travel Insurance Contract (TACTIC)_2023-03 (March 13)',
    appFormTemplate: 'Travel Application Form (A4)_2023-03 (March 01)',
    planTax: 41.41,
    localTax: 4.14,
    gst: 200
  },
  {
    id: '7',
    productCode: 'T',
    planCode: 'I',
    hisPlanId: '2615',
    hisRevNo: '1',
    planDescription: 'Domestic Gold - Individual',
    effectiveDate: '3/1/2024',
    expirationDate: '2/1/2034',
    minimumDays: 32,
    maximumDays: 45,
    currency: 'PHP',
    grossPremium: 3048,
    netPremium: 2786.7,
    mrl: '2500000',
    coverageCode: 'P',
    availableForSalesAgent: false,
    occTemplate: 'OCC MyT_Individual_DOMGold_2023-08 (Aug 15)_COVID19',
    isCancelled: false,
    occPrefix: 'BU',
    tacticTemplate: 'Travel Insurance Contract (TACTIC)_2023-03 (March 13)',
    appFormTemplate: 'Travel Application Form (A4)_2023-03 (March 01)',
    planTax: 55.73,
    localTax: 5.57,
    gst: 200
  },
  {
    id: '8',
    productCode: 'T',
    planCode: 'I',
    hisPlanId: '2615',
    hisRevNo: '1',
    planDescription: 'Domestic Gold - Individual',
    effectiveDate: '3/1/2024',
    expirationDate: '2/1/2034',
    minimumDays: 46,
    maximumDays: 60,
    currency: 'PHP',
    grossPremium: 3728,
    netPremium: 3452.06,
    mrl: '2500000',
    coverageCode: 'P',
    availableForSalesAgent: false,
    occTemplate: 'OCC MyT_Individual_DOMGold_2023-08 (Aug 15)_COVID19',
    isCancelled: false,
    occPrefix: 'BU',
    tacticTemplate: 'Travel Insurance Contract (TACTIC)_2023-03 (March 13)',
    appFormTemplate: 'Travel Application Form (A4)_2023-03 (March 01)',
    planTax: 69.04,
    localTax: 6.9,
    gst: 200
  },
  {
    id: '9',
    productCode: 'T',
    planCode: 'I',
    hisPlanId: '2619',
    hisRevNo: '1',
    planDescription: 'Domestic Bronze - Individual',
    effectiveDate: '3/1/2024',
    expirationDate: '2/1/2034',
    minimumDays: 1,
    maximumDays: 4,
    currency: 'PHP',
    grossPremium: 260,
    netPremium: 156.56,
    mrl: '500000',
    coverageCode: 'P',
    availableForSalesAgent: false,
    occTemplate: 'OCC MyT_Individual_DOMBronze_2023-08 (Aug 15)_COVID19',
    isCancelled: false,
    occPrefix: 'BU',
    tacticTemplate: 'Travel Insurance Contract (TACTIC)_2023-03 (March 13)',
    appFormTemplate: 'Travel Application Form (A4)_2023-03 (March 01)',
    planTax: 3.13,
    localTax: 0.31,
    gst: 100
  },
  {
    id: '10',
    productCode: 'T',
    planCode: 'I',
    hisPlanId: '2619',
    hisRevNo: '1',
    planDescription: 'Domestic Bronze - Individual',
    effectiveDate: '3/1/2024',
    expirationDate: '2/1/2034',
    minimumDays: 5,
    maximumDays: 7,
    currency: 'PHP',
    grossPremium: 436,
    netPremium: 328.76,
    mrl: '500000',
    coverageCode: 'P',
    availableForSalesAgent: false,
    occTemplate: 'OCC MyT_Individual_DOMBronze_2023-08 (Aug 15)_COVID19',
    isCancelled: false,
    occPrefix: 'BU',
    tacticTemplate: 'Travel Insurance Contract (TACTIC)_2023-03 (March 13)',
    appFormTemplate: 'Travel Application Form (A4)_2023-03 (March 01)',
    planTax: 6.58,
    localTax: 0.66,
    gst: 100
  },
  {
    id: '11',
    productCode: 'T',
    planCode: 'I',
    hisPlanId: '2619',
    hisRevNo: '1',
    planDescription: 'Domestic Bronze - Individual',
    effectiveDate: '3/1/2024',
    expirationDate: '2/1/2034',
    minimumDays: 8,
    maximumDays: 10,
    currency: 'PHP',
    grossPremium: 532,
    netPremium: 422.7,
    mrl: '500000',
    coverageCode: 'P',
    availableForSalesAgent: false,
    occTemplate: 'OCC MyT_Individual_DOMBronze_2023-08 (Aug 15)_COVID19',
    isCancelled: false,
    occPrefix: 'BU',
    tacticTemplate: 'Travel Insurance Contract (TACTIC)_2023-03 (March 13)',
    appFormTemplate: 'Travel Application Form (A4)_2023-03 (March 01)',
    planTax: 8.45,
    localTax: 0.85,
    gst: 100
  },
  {
    id: '12',
    productCode: 'T',
    planCode: 'I',
    hisPlanId: '2613',
    hisRevNo: '1',
    planDescription: 'Asia and Oceania Peso - Ind',
    effectiveDate: '3/1/2024',
    expirationDate: '2/1/2034',
    minimumDays: 1,
    maximumDays: 4,
    currency: 'PHP',
    grossPremium: 542,
    netPremium: 334.64,
    mrl: '1500000',
    coverageCode: 'E',
    availableForSalesAgent: false,
    occTemplate: 'OCC MyT_Individual_AOPeso_2023-08 (Aug 15)_COVID19',
    isCancelled: false,
    occPrefix: 'BU',
    tacticTemplate: 'Travel Insurance Contract (TACTIC)_2023-03 (March 13)',
    appFormTemplate: 'Travel Application Form (A4)_2023-03 (March 01)',
    planTax: 6.69,
    localTax: 0.67,
    gst: 200
  },
  {
    id: '13',
    productCode: 'T',
    planCode: 'I',
    hisPlanId: '2613',
    hisRevNo: '1',
    planDescription: 'Asia and Oceania Peso - Ind',
    effectiveDate: '3/1/2024',
    expirationDate: '2/1/2034',
    minimumDays: 5,
    maximumDays: 7,
    currency: 'PHP',
    grossPremium: 852,
    netPremium: 637.96,
    mrl: '1500000',
    coverageCode: 'E',
    availableForSalesAgent: false,
    occTemplate: 'OCC MyT_Individual_AOPeso_2023-08 (Aug 15)_COVID19',
    isCancelled: false,
    occPrefix: 'BU',
    tacticTemplate: 'Travel Insurance Contract (TACTIC)_2023-03 (March 13)',
    appFormTemplate: 'Travel Application Form (A4)_2023-03 (March 01)',
    planTax: 12.76,
    localTax: 1.28,
    gst: 200
  },
  {
    id: '14',
    productCode: 'T',
    planCode: 'I',
    hisPlanId: '2613',
    hisRevNo: '1',
    planDescription: 'Asia and Oceania Peso - Ind',
    effectiveDate: '3/1/2024',
    expirationDate: '2/1/2034',
    minimumDays: 8,
    maximumDays: 10,
    currency: 'PHP',
    grossPremium: 1009,
    netPremium: 791.59,
    mrl: '1500000',
    coverageCode: 'E',
    availableForSalesAgent: false,
    occTemplate: 'OCC MyT_Individual_AOPeso_2023-08 (Aug 15)_COVID19',
    isCancelled: false,
    occPrefix: 'BU',
    tacticTemplate: 'Travel Insurance Contract (TACTIC)_2023-03 (March 13)',
    appFormTemplate: 'Travel Application Form (A4)_2023-03 (March 01)',
    planTax: 15.83,
    localTax: 1.58,
    gst: 200
  },
  {
    id: '15',
    productCode: 'T',
    planCode: 'I',
    hisPlanId: '2613',
    hisRevNo: '1',
    planDescription: 'Asia and Oceania Peso - Ind',
    effectiveDate: '3/1/2024',
    expirationDate: '2/1/2034',
    minimumDays: 11,
    maximumDays: 15,
    currency: 'PHP',
    grossPremium: 1108,
    netPremium: 888.45,
    mrl: '1500000',
    coverageCode: 'E',
    availableForSalesAgent: false,
    occTemplate: 'OCC MyT_Individual_AOPeso_2023-08 (Aug 15)_COVID19',
    isCancelled: false,
    occPrefix: 'BU',
    tacticTemplate: 'Travel Insurance Contract (TACTIC)_2023-03 (March 13)',
    appFormTemplate: 'Travel Application Form (A4)_2023-03 (March 01)',
    planTax: 17.77,
    localTax: 1.78,
    gst: 200
  }
];